import { render, staticRenderFns } from "./BaseInfoWeek.vue?vue&type=template&id=6135ae14"
import script from "./BaseInfoWeek.vue?vue&type=script&lang=js"
export * from "./BaseInfoWeek.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports